import { createSlice } from '@reduxjs/toolkit';
import { ProductAlias } from '@ibk/shared-types';
const initialProductState = {
    data: null,
    isLoading: false,
    error: null,
};
const initialState = {
    [ProductAlias.CONTA_DIGITAL]: { ...initialProductState },
    [ProductAlias.COBRANCAS]: { ...initialProductState },
    [ProductAlias.CONTABILIDADE_DIGITAL]: { ...initialProductState },
    [ProductAlias.BENEFICIOS]: { ...initialProductState },
    [ProductAlias.DOMINIO_RECOMPENSAS]: { ...initialProductState },
};
const productsSlice = createSlice({
    name: 'products',
    initialState,
    reducers: {
        setProductLoading: (state, action) => {
            const { productAlias, isLoading } = action.payload;
            state[productAlias].isLoading = isLoading;
            if (isLoading) {
                state[productAlias].error = null;
            }
        },
        setProductData: (state, action) => {
            const { productAlias, data } = action.payload;
            state[productAlias].data = data;
            state[productAlias].isLoading = false;
            state[productAlias].error = null;
        },
        setProductError: (state, action) => {
            const { productAlias, error } = action.payload;
            state[productAlias].error = error;
            state[productAlias].isLoading = false;
        },
        clearAllProducts: state => {
            Object.keys(state).forEach(key => {
                const productAlias = key;
                state[productAlias] = { ...initialProductState };
            });
        },
    },
});
export const { setProductLoading, setProductData, setProductError, clearAllProducts } = productsSlice.actions;
export default productsSlice.reducer;
